import { render, staticRenderFns } from "./UserAdministration.vue?vue&type=template&id=1cba3248&scoped=true&"
import script from "./UserAdministration.vue?vue&type=script&lang=ts&"
export * from "./UserAdministration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba3248",
  null
  
)

export default component.exports